<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="8">
          <v-file-input
            v-model="files"
            label="File"
            accept=".pdf"
            prepend-icon="mdi-file-pdf-box"
            placeholder="Upload PDF File"
            outlined
            dense
            clearable
            multiple
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-btn @click="uploadFile" color="success" class="mr-2">
            <v-icon>
              mdi-file-upload
            </v-icon>
          </v-btn>
          <v-btn @click="routeToBuffer" color="primary">
            <v-icon>
              mdi-table
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" dense hide-default-footer disable-pagination>
        <template v-slot:item.no="{ item }">
          {{ items.map(x => x).indexOf(item) + 1 }}
        </template>
        <template v-slot:item.vendor_name="{ item }">
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model="item.vendor_name"
            ></v-text-field>
          </v-col>
        </template>
        <template v-slot:item.invoice_number="{ item }">
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model="item.invoice_number"
            ></v-text-field>
          </v-col>
        </template>
        <template v-slot:item.invoice_date="{ item }">
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model="item.invoice_date"
              hint="format harus YYYY-MM-DD (contoh: 2023-01-01)"
              persistent-hint
            ></v-text-field>
          </v-col>
        </template>
        <template v-slot:item.reference_number="{ item }">
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model="item.reference_number"
            ></v-text-field>
          </v-col>
        </template>
        <template v-slot:item.invoice_amount="{ item }">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model.number="item.invoice_amount"
            :hint="formatPrice(item.invoice_amount)"
            persistent-hint
            type="number"
          ></v-text-field>
        </template>
        <template v-slot:item.action="{ item }">
          <v-checkbox
            v-model="item.is_selected"
            outlined
            flat
            dense
            background-color="white"
          ></v-checkbox>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="saveBuffer" color="primary">
        <v-icon>
          mdi-content-save
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "report-ocr-pdf",
  data() {
    return {
      items: [],
      files: [],
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Vendor",
          value: "vendor_name",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Invoice#",
          value: "invoice_number",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Date",
          value: "invoice_date",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "PO#",
          value: "reference_number",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "DPP",
          value: "invoice_amount",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    async uploadFile() {
      const formData = new FormData();
      this.files.forEach(file => {
        formData.append("files", file);
      });

      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchaseInvoice/ocrInvoiceMultiple", formData)
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    routeToBuffer() {
      this.$router.push({ name: "Buffer Invoice PDF" });
    },
    async saveBuffer() {
      const body = this.items.filter(item => item.is_selected);
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchaseInvoice/saveBufferInvoicePdf", body)
        .then(() => {
          this.routeToBuffer();
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
};
</script>

<style scoped></style>
